var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 29.965 22.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.037,5.618H.945A.9.9,0,0,1,.287,5.34a.9.9,0,0,1-.278-.657V.936A.9.9,0,0,1,.287.278.9.9,0,0,1,.945,0H29.037A.9.9,0,0,1,29.7.278a.9.9,0,0,1,.278.658V4.682a.95.95,0,0,1-.936.936ZM2.818,7.491H27.165a.95.95,0,0,1,.936.936v13.11a.95.95,0,0,1-.936.936H2.818a.95.95,0,0,1-.936-.936V8.428a.9.9,0,0,1,.278-.658.9.9,0,0,1,.658-.278ZM10.557,16.7a.95.95,0,0,0,.936.936h7.364a.95.95,0,0,0,.936-.936V13.082a.95.95,0,0,0-.936-.936H11.493a.95.95,0,0,0-.936.936V16.7Z",
    transform: "translate(-0.009)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "static/media/shipment.29c40f421cbea8677853e7704fc25552.svg";
export { ForwardRef as ReactComponent };